import React from 'react'
import ReactDOM from 'react-dom/client'
import './styles/tokens.css'
import App from './App'
const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<App />)

// Service worker with auto-update
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(reg => {
      // Check for updates every 5 minutes
      setInterval(() => reg.update(), 5 * 60 * 1000);

      reg.addEventListener('updatefound', () => {
        const newWorker = reg.installing;
        if (!newWorker) return;
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            // New version available — show update banner
            const banner = document.createElement('div');
            banner.style.cssText = 'position:fixed;bottom:0;left:0;right:0;background:#1a1a1a;color:#fff;padding:12px 16px;display:flex;align-items:center;justify-content:space-between;z-index:99999;font-family:sans-serif;font-size:14px';
            banner.innerHTML = '<span>Hay una actualización disponible</span>';
            const btn = document.createElement('button');
            btn.textContent = 'Actualizar';
            btn.style.cssText = 'background:linear-gradient(135deg,#534AB7,#1D9E75);color:#fff;border:none;border-radius:50px;padding:8px 20px;font-size:13px;cursor:pointer;font-weight:500';
            btn.onclick = () => { newWorker.postMessage({ type: 'SKIP_WAITING' }); window.location.reload(); };
            banner.appendChild(btn);
            document.body.appendChild(banner);
          }
        });
      });
    }).catch(() => {});
  });

  // Reload when new SW takes over
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    window.location.reload();
  });
}
